import { Router } from '@angular/router';
import { FlamingoAuthService } from '@flamingo/service/flamingo-auth.service';
import { MainService } from './children/main/main.service';
import { AccountView } from './core/model/account-view.model';
import { UserType } from './core/model/user.model';
import { NavigationService } from './navigation/navigation.service';

export function initializeApp(
  authService: FlamingoAuthService,
  mainService: MainService,
  navigationService: NavigationService,
  router: Router,
): () => Promise<void> {
  return (): Promise<void> => {
    return new Promise((resolve, reject) => {
      console.log('Startup App');
      const token = authService.getToken();
      if (token) {
        authService.updateUserFromToken();
        mainService.getAccount()
          .subscribe(
            res => {
              // logout if change role
              if (authService.user.type !== res.profileType) {
                authService.logout();
                switch (res.profileType) {
                  case UserType.seller:
                    router.navigate(['/auth']);
                    break;
                  case UserType.buyer:
                    router.navigate(['/buyer/auth']);
                    break;
                  case UserType.partner:
                  case UserType.partnerBranchMaster:
                  case UserType.partnerAgent:
                    router.navigate(['/partner/auth']);
                    break;
                  default:
                    router.navigate(['/auth']);
                    break;
                }
              }

              mainService.user = res as AccountView;

              const showNavigation =
                !!mainService.user.companyStatus &&
                mainService.user.companyStatus !== 'PENDING_VALIDATION' &&
                mainService.user.companyStatus !== 'REJECTED' &&
                mainService.user.companyStatus !== 'PROFILE_CONFIRM' &&
                mainService.user.companyStatus !== 'DEACTIVATED' &&
                mainService.user.companyStatus !== 'LEAD' &&
                mainService.user.companyStatus !== 'DANGEROUS';
              navigationService.setNavigation(showNavigation);

              resolve();
            },
            _ => {
              authService.logout();
              resolve();
            },
          );
      } else {
        resolve();
      }
    });
  };
}
